import { Skeleton, SkeletonTableRow } from './Skeleton';

/**
 * Loading skeleton for the Expenses page
 */
export function ExpensesPageSkeleton() {
  return (
    <>
      {/* Filters Bar Skeleton */}
      <div className="bg-white rounded-lg border border-[#E2E8F0] p-4 mb-6">
        <div className="flex items-center gap-3">
          <Skeleton height={40} className="flex-1" />
          <Skeleton height={40} width={120} />
          <Skeleton height={40} width={100} />
        </div>
      </div>

      {/* Results Summary Skeleton */}
      <div className="bg-white rounded-lg border border-[#E2E8F0] p-4 mb-6">
        <div className="flex items-center justify-between">
          <Skeleton height={16} width={200} />
          <Skeleton height={16} width={150} />
        </div>
      </div>

      {/* Expense Table Skeleton */}
      <div className="bg-white rounded-lg border border-[#E2E8F0] overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-[#F7FAFC] border-b border-[#E2E8F0]">
              <tr>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={60} />
                </th>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={80} />
                </th>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={100} />
                </th>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={70} />
                </th>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={90} />
                </th>
                <th className="px-4 py-3 text-left">
                  <Skeleton height={14} width={80} />
                </th>
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 8 }).map((_, i) => (
                <SkeletonTableRow key={i} columns={6} />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
